<app-table [data]="toolsGrouped"
           [treeMode]="true"
           [config]="tableConfig"
           [groupableColumns]="groupableColumns"
           [isLoading]="isLoading"
           title="{{'admin.tools.title' | translate}}"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (groupChange)="onGroupChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column header="{{'admin.tools.table.columns.name' | translate}}"
                      sortable="true"
                      filter="true"
                      [showTree]="true"
                      field="name">
    </app-table-column>
    <app-table-column header="{{'admin.tools.table.columns.id' | translate}}"
                      sortable="true"
                      filter="true"
                      field="id">
    </app-table-column>
    <app-table-column header="{{'admin.tools.table.columns.status' | translate}}"
                      sortable="true"
                      filter="true"
                      field="status">
    </app-table-column>
    <app-table-column header="{{'admin.tools.table.columns.available' | translate}}"
                      sortable="true"
                      filter="true"
                      field="isAvailableForManufactoring">

    </app-table-column>
    <!-- TODO  Add YES/NO functionality to isAvailableForManufactoring -->
    <app-table-column cls="action">
        <ng-template #body
                     let-tool="record">
            <a *ngIf="tool.type === 'tool'"
               class="waves-effect btn-flat"
               (click)="openToolDetails(tool)">
                <i class="material-icons">open_in_new</i>
            </a>
        </ng-template>
    </app-table-column>
</app-table>
